// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "contact_preference.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "contact_preference.proto" (syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
// @generated message type with reflection information, may provide speed optimized methods
class ContactPreference$Type extends MessageType {
    constructor() {
        super("ContactPreference", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "active", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "sort_order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.label = "";
        message.active = 0;
        message.sortOrder = 0;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.withoutLimit = false;
        message.orderBy = "";
        message.orderDir = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string label */ 2:
                    message.label = reader.string();
                    break;
                case /* int32 active */ 3:
                    message.active = reader.int32();
                    break;
                case /* int32 sort_order */ 4:
                    message.sortOrder = reader.int32();
                    break;
                case /* repeated string field_mask */ 5:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 6:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 7:
                    message.withoutLimit = reader.bool();
                    break;
                case /* string order_by */ 8:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 9:
                    message.orderDir = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string label = 2; */
        if (message.label !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.label);
        /* int32 active = 3; */
        if (message.active !== 0)
            writer.tag(3, WireType.Varint).int32(message.active);
        /* int32 sort_order = 4; */
        if (message.sortOrder !== 0)
            writer.tag(4, WireType.Varint).int32(message.sortOrder);
        /* repeated string field_mask = 5; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 6; */
        if (message.pageNumber !== 0)
            writer.tag(6, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 7; */
        if (message.withoutLimit !== false)
            writer.tag(7, WireType.Varint).bool(message.withoutLimit);
        /* string order_by = 8; */
        if (message.orderBy !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 9; */
        if (message.orderDir !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.orderDir);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ContactPreference
 */
export const ContactPreference = new ContactPreference$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContactPreferenceList$Type extends MessageType {
    constructor() {
        super("ContactPreferenceList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ContactPreference },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ContactPreference results */ 1:
                    message.results.push(ContactPreference.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ContactPreference results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ContactPreference.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ContactPreferenceList
 */
export const ContactPreferenceList = new ContactPreferenceList$Type();
/**
 * @generated ServiceType for protobuf service ContactPreferenceService
 */
export const ContactPreferenceService = new ServiceType("ContactPreferenceService", [
    { name: "Create", options: {}, I: ContactPreference, O: ContactPreference },
    { name: "Get", options: {}, I: ContactPreference, O: ContactPreference },
    { name: "BatchGet", options: {}, I: ContactPreference, O: ContactPreferenceList },
    { name: "Update", options: {}, I: ContactPreference, O: ContactPreference },
    { name: "Delete", options: {}, I: ContactPreference, O: ContactPreference }
]);
